import { type } from "arktype";

export const classificationFormSchema = type({
	explanation: "string >= 1",
	destination: "string >= 1",
	expenseCategoryId:
		"'bank_fee' | 'collaborators' | 'electricity' | 'insurance' | 'maintenance' | 'software_services' | 'forklift_gas' | null",
});

export type ClassificationForm = typeof classificationFormSchema.infer;
